import type { ReactNode } from 'react'
import { Provider } from 'react-redux'

import { store } from './store'

export { useAppDispatch, useAppSelector } from './hooks'
export {
  changeAuthorization,
  getListSystemKey,
  selectIsAppInitialized,
  selectListSystemKey,
  setAppInitialized,
  setListMenu,
  setListTabs,
  setUserInfo,
} from './slices/appGlobal.slice'

export function ReduxProvider({ children }: { readonly children: ReactNode }) {
  return <Provider store={store}>{children}</Provider>
}
